import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgGroeneHaagOnderhoud = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="m33.76 17.68-3.39-2a.8.8 0 0 0-.62-.06 1.16 1.16 0 0 1 0 1.24 1.17 1.17 0 0 1-1.6.43h-.06a.8.8 0 0 0 .06.62l2 3.4a.78.78 0 0 0 1.07.28.77.77 0 0 0 .29-1.07l-1.93-3.35.06-.05L33 19a.785.785 0 0 0 1.01-1.159.8.8 0 0 0-.23-.201zM20.21 11.36a.32.32 0 0 0-.44.43A11.07 11.07 0 0 0 23.53 16a5.82 5.82 0 0 0 4.13.67 1.16 1.16 0 0 1 .1-.94.27.27 0 0 1-.15 0z"
    />
    <path
      fill="#60D15D"
      d="M28.39 17a.79.79 0 0 0 1.07-.29.8.8 0 0 0-.29-1.07.784.784 0 0 0-.78 1.36"
    />
    <path
      fill="#B3E9B1"
      d="M27.5 21.5a2.48 2.48 0 0 0-1.26-2.16 1.5 1.5 0 0 0 .26-.84 1.47 1.47 0 0 0-.5-1.14 2 2 0 0 0 0-2.72 1.47 1.47 0 0 0 .54-1.14 1.5 1.5 0 0 0-.39-1A1.49 1.49 0 0 0 25 10a1.5 1.5 0 0 0-.56.11 1.49 1.49 0 0 0-2.88 0A1.5 1.5 0 0 0 21 10a1.5 1.5 0 0 0-1 .39 1.5 1.5 0 0 0-1-.39 1.5 1.5 0 0 0-.68.17 2 2 0 0 0-3.82.83v.28a2 2 0 0 0-1 1.72 2 2 0 0 0 .69 1.5 2 2 0 0 0-.25 2.74 2.49 2.49 0 0 0-.18 4.42 1.5 1.5 0 0 0-.26.84 1.47 1.47 0 0 0 .5 1.14 2 2 0 0 0 .15 2.86 2 2 0 0 0-.27 2.71 1 1 0 0 0-.42.79 1 1 0 0 0 1 1h11a1 1 0 0 0 .41-1.91 2.47 2.47 0 0 0 .59-1.59 2.5 2.5 0 0 0-.7-1.73 1.5 1.5 0 0 0 .44-2.11 2.48 2.48 0 0 0 1.3-2.16"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20.5 14v15h-1V14z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m22.354 23.354-2 2-.707-.708 2-2zM22.354 18.354l-2 2-.707-.708 2-2zM18.354 25.646l2 2-.707.708-2-2zM18.354 14.646l2 2-.707.708-2-2z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M21.47 18.82a4.25 4.25 0 0 0 .53 2.64 4.24 4.24 0 0 0 1.42-2.28 4.25 4.25 0 0 0-.55-2.64 4.24 4.24 0 0 0-1.4 2.28M18.71 23.28a4.23 4.23 0 0 0 2.68.23 4.24 4.24 0 0 0-1.78-2 4.26 4.26 0 0 0-2.69-.23 4.27 4.27 0 0 0 1.79 2M21.78 24.74a4.3 4.3 0 0 0-1.32 2.35c.91.017 1.8-.26 2.54-.79a4.25 4.25 0 0 0 1.36-2.3 4.26 4.26 0 0 0-2.58.74M20.39 29.46a4.27 4.27 0 0 0-2.65-.5 4.26 4.26 0 0 0 1.57 2.19 4.27 4.27 0 0 0 2.65.5 4.26 4.26 0 0 0-1.57-2.19"
    />
    <path
      fill="#60D15D"
      d="M17.89 29.31a4.26 4.26 0 0 0-2.57.81 4.22 4.22 0 0 0 2.42 1.18 4.26 4.26 0 0 0 2.57-.81 4.22 4.22 0 0 0-2.42-1.18"
    />
    <path
      fill="#60D15D"
      d="M22.32 31.23a4.25 4.25 0 0 0 2.36-1.3 4.24 4.24 0 0 0-2.61-.68 4.2 4.2 0 0 0-2.35 1.29 4.2 4.2 0 0 0 2.6.69M28.12 15.34a1.19 1.19 0 0 1 1-.16 5.8 5.8 0 0 0-.68-4.06 11.3 11.3 0 0 0-4.2-3.77.32.32 0 0 0-.43.45l4.28 7.41a.7.7 0 0 1 .03.13"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgGroeneHaagOnderhoud);

export default ForwardRef;
